var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-w-full tw-h-full tw-fixed tw-block tw-top-0 tw-left-0 tw-bg-white tw-opacity-75 tw-z-50",class:{ 'tw-absolute': _vm.absolute }},[_c('LoadingIndicator',{staticClass:"tw-opacity-75 tw-top-1/2 tw-my-0 tw-mx-auto tw-relative tw--mt-16",attrs:{"size":64}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }